export default __webpack_public_path__ + "static/rajasthan-bike-tour-4-4763a4a2640e2f55a370971ed3a5c6f7.jpg";